import { render } from "./AddonViewProcessing.vue?vue&type=template&id=0d0c178c&scoped=true&ts=true"
import script from "./AddonViewProcessing.vue?vue&type=script&lang=ts"
export * from "./AddonViewProcessing.vue?vue&type=script&lang=ts"

import "./AddonViewProcessing.vue?vue&type=style&index=0&id=0d0c178c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0c178c"]])

export default __exports__